import type { MediaFileCharacters } from "@next-platform/client-common-core/viewMedia/types/MediaFileCharacters";
import { useCallback, useMemo } from "react";

import useLocalizedNavigation from "@/hooks/useLocalizedNavigation";

import getMediaFileConnectionPath from "../MediaFilePreview/getMediaFileConnectionPath";

/**
 * Opens a related entity from its card. The view hands back only the id, so each card's destination is looked up
 * from the entity it was built from; the primary chatbot is added last and wins a shared id, since it carries the chat.
 */
export default function useMediaFileConnectionNavigation({ primaryCharacter, connections }: MediaFileCharacters) {
  const navigate = useLocalizedNavigation();
  const connectionPaths = useMemo(
    () =>
      new Map(
        [...connections, ...(primaryCharacter ? [primaryCharacter] : [])].map((connection) => [
          connection.id,
          getMediaFileConnectionPath(connection),
        ]),
      ),
    [primaryCharacter, connections],
  );

  return useCallback(
    (connectionId: string) => {
      const path = connectionPaths.get(connectionId);
      if (path) {
        navigate(path);
      }
    },
    [navigate, connectionPaths],
  );
}
